// extracted by mini-css-extract-plugin
export default {"base":"vp_s_Fn7"};